import { ApolloQueryResult } from '@apollo/client';
import {
  DelayQuestionMutationFn,
  SkipQuestionMutationFn,
  TrialInfoQuery,
  TrialInfoQueryResult,
} from '@generated/graphql';
import { createContext, Dispatch, SetStateAction } from 'react';
import { RemainingTime } from './types';

export interface QuestionPageContextValue {
  isDelayLoading: boolean;
  setIsDelayLoading: Dispatch<SetStateAction<boolean>>;
  isSkipLoading: boolean;
  setIsSkipLoading: Dispatch<SetStateAction<boolean>>;
  delayQuestion: DelayQuestionMutationFn | null;
  delayQuestionLoading: boolean;
  skipQuestion: SkipQuestionMutationFn | null;
  skipQuestionLoading: boolean;
  handleFinishTesting: () => void;
  handleFinishQuestion:
    | ((refetchTrial?: boolean) => Promise<ApolloQueryResult<TrialInfoQuery>> | null)
    | null;
  isLastQuestion: boolean;
  refetchTrialInfo: TrialInfoQueryResult['refetch'] | null;
  remainingTime: RemainingTime;
}

export const QuestionPageContext = createContext<QuestionPageContextValue>({
  isDelayLoading: false,
  setIsDelayLoading: () => {},
  isSkipLoading: false,
  setIsSkipLoading: () => {},
  delayQuestion: null,
  delayQuestionLoading: false,
  skipQuestion: null,
  skipQuestionLoading: false,
  handleFinishTesting: () => {},
  handleFinishQuestion: null,
  isLastQuestion: false,
  refetchTrialInfo: null,
  remainingTime: null,
});
